import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// Taken from: https://github.com/verekia/simple-cell
// This component and hook delay showing a spinner by a certain time
export var useDeferredLoading = function() {
    var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 300;
    var ref = useState(false), show = ref[0], setShow = ref[1];
    useEffect(function() {
        var timer = setTimeout(function() {
            return setShow(true);
        }, delay);
        return function() {
            return clearTimeout(timer);
        };
    });
    return show;
};
var DeferredLoading = function(param) {
    var children = param.children, delay = param.delay;
    var show = useDeferredLoading(delay);
    return show ? /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    }) : null;
};
DeferredLoading.propTypes = {
    children: PropTypes.node,
    delay: PropTypes.number
};
export default DeferredLoading;
